import { useSelector } from 'react-redux';

import { Preferences } from '@atom/types/preferences';
import { RootState } from '@atom/types/store';

export const usePreferences = (): Preferences => {
  return useSelector((state: RootState) => state.preferences);
};
